// Copyright (c) 2019 by Michael Marucheck
//
// Use of this source code is governed by an MIT-style license that
// can be found in the LICENSE file distributed with this file.

import React, { useState, useEffect } from "react";
import { Link, RouteComponentProps } from "react-router-dom";
import "../components/common.css";

import { ACTIVITY_STATUS, URLS } from "../urls";
import { coordCache } from "../store/api";
import { update } from "../UiUtil";
import { PageContainer } from "../components/PageContainer";
import { downloadAll } from "../store/XlsxReporter";

type PageProps = RouteComponentProps<{}>;

export const HomePage: React.FC<PageProps> = () => {
  debug("======= IndexPage =======");
  const [state, setState] = useState(coordCache().get());

  const { school, user } = state;

  useEffect(() => {
    return coordCache().subscribe(newState => {
      debug("Updating state");
      update("setState", state, setState, newState);
    });
  });

  return (
    <PageContainer
      title="Volunteer Coordinator Overview"
      crumbs={[]}
      administrators={state.administrators}
      school={school}
      checks={{ user }}
    >
      <>
        <div className="nav">
          <Link to={URLS.cActivities(ACTIVITY_STATUS.pending)}>
            Pending Activities
          </Link>
        </div>
        <div className="nav">
          <Link to={URLS.cActivities(ACTIVITY_STATUS.rejected)}>
            Questioned Activities
          </Link>
        </div>
        <div className="nav">
          <Link to={URLS.cActivities(ACTIVITY_STATUS.approved)}>
            Approved Activities
          </Link>
        </div>
        <div className="nav">
          <Link to={URLS.cActivities(ACTIVITY_STATUS.all)}>
            All Activities
          </Link>
        </div>
        {state.loaded && (
          <div className="nav">
            <button type="button" onClick={() => downloadAll(state)}>
              Download XLSX Report
            </button>
          </div>
        )}
      </>
    </PageContainer>
  );
};

function debug(message: string) {
  if (true) {
    console.log(`IndexPage: ${message}`);
  }
}
